import { useFlags } from "launchdarkly-react-client-sdk";

function toCamelCase(key) {
  return key.replace(/-([a-z])/g, (_, c) => c.toUpperCase());
}

export function useFeatureFlag(flagKey, defaultValue = false) {
  const flags = useFlags();
  return flags[toCamelCase(flagKey)] ?? defaultValue;
}
